import React from 'react'

const Manual_menu_item_precios_multiples = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Menú - Ítem Precios Múltiples
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Esta guía explica cómo añadir múltiples precios a los platos del menú, permitiendo una gestión flexible y precisa de los precios según el tipo de pedido. Es una herramienta clave para gerentes de restaurantes que buscan optimizar su menú y mejorar la satisfacción del cliente.
        </p>
        <iframe
          src="https://scribehow.com/embed/Menu__Item_Precios_Multiples__mtgDMZwzRh20bwZd80blIw?as=scrollable"
          className="scribe-iframe-general-33"
          width="100%"
          height="3600"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_menu_item_precios_multiples